<template>
  <div>
    <com-dialog :visible.sync="visible" width="40%" title="详情">
      <div>
        <div>
          <el-descriptions :column="1">
            <template v-if="form.viewType === 'feedBack'">
              <el-descriptions-item label="问题类型">{{ form.type }}</el-descriptions-item>
              <el-descriptions-item label="问题过程描述">{{
                form.description
              }}</el-descriptions-item>
            </template>
            <template v-else>
              <el-descriptions-item label="需求描述">{{ form.description }}</el-descriptions-item>
            </template>
            <el-descriptions-item label="联系方式">{{ form.phone }}</el-descriptions-item>
            <el-descriptions-item label="图片">
              <div v-for="(item, index) in form.pics" :key="index">
                <el-image :src="item.url | filterImage" v-if="item.url"></el-image>
                <el-image :src="item | filterImage" v-else></el-image>
              </div>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="flex items-center justify-end mt-15px">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="confirm">确定</el-button>
        </div>
      </div>
    </com-dialog>
  </div>
</template>

<script>
import utils from 'my-tools-library'

export default {
  data() {
    return {
      visible: false,
      type: '',
      form: {}
    }
  },
  methods: {
    open(opt) {
      this.form = utils.deepCopy(opt)
      this.form.pics = utils.handleJsonImg(this.form.pics)
      console.log('row :>> ', this.form)

      this.visible = true
    },
    close() {
      this.visible = false
      setTimeout(() => {
        this.form = {}
      }, 200)
    },
    changeEditorValue(val) {
      this.form.value = val
    },
    confirm() {}
  }
}
</script>

<style lang="scss" scoped></style>
